// VoK MUI helper functions
import pxToRem from "app/assets/theme/functions/pxToRem";

// VoK MUI base styles
import colors from "app/assets/theme/base/colors";
import boxShadows from "app/assets/theme/base/boxShadows";
import borders from "app/assets/theme/base/borders";

const {transparent} = colors;
const {lg} = boxShadows;
const {borderRadius} = borders;

const popover = {
    styleOverrides: {
        paper: {
            backgroundColor: transparent.main,
            boxShadow: lg,
            padding: pxToRem(8),
            borderRadius: borderRadius.lg,
        },
    },
};

export default popover;
